import {UploadType} from "./upload.types";
import {CmsApiService} from "../cms-api.service";

export function getUploadUrls(cms: CmsApiService): Record<UploadType, string> {
  return {
    [UploadType.IMAGE]: cms.getApiUrl(cms.API_IMAGE_ORDER_UPLOAD_URL, true),
    [UploadType.VIDEO]: cms.getApiUrl(cms.API_VIDEO_ORDER_UPLOAD_URL, true),
    [UploadType.ATTACHMENT]: cms.getApiUrl(cms.API_ATTACHMENT_ORDER_UPLOAD_URL, true),
    [UploadType.AUDIO]: cms.getApiUrl(cms.API_AUDIO_ORDER_UPLOAD_URL, true),
    [UploadType.MODEL3D]: cms.getApiUrl(cms.API_MODEL3D_ORDER_UPLOAD_URL, true),
  };
}

export function uploadTypeFromFile(file: File): UploadType {
  const fileType = file.type;
  const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  if (fileType.startsWith('image/')) {
    return UploadType.IMAGE;
  } else if (fileType.startsWith('video/')) {
    return UploadType.VIDEO;
  } else if (fileType.startsWith('audio/')) {
    return UploadType.AUDIO;
  } else if (['model/gltf-binary', 'model/gltf+json'].includes(fileType) || ['glb', 'gltf'].includes(fileExtension)) {
    return UploadType.MODEL3D;
  } else {
    // Default to `attachment` for other file types
    return UploadType.ATTACHMENT;
  }
}
